import { render, staticRenderFns } from "./CampaignKpiBoxInfo.vue?vue&type=template&id=b825e346&scoped=true&"
import script from "./CampaignKpiBoxInfo.vue?vue&type=script&lang=js&"
export * from "./CampaignKpiBoxInfo.vue?vue&type=script&lang=js&"
import style0 from "./CampaignKpiBoxInfo.vue?vue&type=style&index=0&id=b825e346&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b825e346",
  null
  
)

export default component.exports